import { Component } from '@angular/core';

/**
 * Componente raíz de la aplicación.
 *
 * Este componente actúa como el contenedor principal de toda la aplicación Angular.
 * Su estructura define el punto de entrada visual y funcional del proyecto.
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {}
